import { render } from "./SummaryRow.vue?vue&type=template&id=25bb2207"
import script from "./SummaryRow.vue?vue&type=script&lang=js"
export * from "./SummaryRow.vue?vue&type=script&lang=js"
script.render = render

export default script